
import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Loguin from "./tools/Loguin";
import FormNuevoExpte from "./Expedientes/formNuevoExpte";
import Edit from "./tools/Edit";
import GeneraCaratula from "./Expedientes/generaCaratula";
import ConsultaExpediente from "./Expedientes/ConsultaExpediente";
import QRscanner from "./modulos/QRscanner";
import ModuloUsuarios from "./modulos/moduloUsuarios";
import CambiaContrasena from "./modulos/CambiaContrasena";
import DevuelveLegajoInscripto from "./modulos/DevuelveLegajoInscripto";
import Cadetes from "./cadetes/Cadetes";
import Procesos from "./Ingresos/Procesos";
import Certificados from "./certificados/Certificados";
import Constancia from "./certificados/Constancia";
import GeneraRecibo from "./Expedientes/generaRecibo";
import EnvioMasivo from "./tools/EnvioMasivo";
import Docentes from "./Docentes/Docentes";
import NCadetes from "./NCadetes/NCadetes";
import Calificaciones from "./Calificaciones/Calificaciones";
import Resoluciones from "./Resoluciones/Resoluciones";
import Documentos from "./documentos/Documentos";
import Reempadronamiento from "./NCadetes/Reempadronamiento";
import CadetesEdit from "./NCadetes/CadetesEdit";
import CompoLuis from "./NCadetes/compoLuis";
import CreaSancion from "./NCadetes/CreaSancion";
import GuardiaPrevencion from "./GuardiaPrevencion/GuardiaPrevencion";
import DivisionCuerpo from "./Cuerpo/DivisionCuerpo";
import DivisionEstudio from "./Estudios/DivisionEstudio";
import Sanidad from "./Sanidad/Sanidad";
import SelectorCompaniaSeccion from "./Cuerpo/SelectorCompaniaSeccion";
import Sancionaa from "./NCadetes/sancionaa";
import Main from "./Docentes/Main";
import Logistica from "./Logistica/Logistica";
import socket from "./tools/socke";
import WebSocketHandler from "./tools/WebSocketHandler";
import TimmerGlobal from "./tools/TimmerGlobal";
import DTyD from "./tools/DTyD";
import Psico from "./Psicopedagogico/Pisco";
import ReporteAsistenciaDocentes from "./Docentes/ReporteAsistenciaDocentes";
import NotFound from "./tools/NotFound";
import MenuIngresos from "./Ingresos/MenuIngresos";
import FormEditaDocente from "./Docentes/formEditaDocente";
import AsignacionesSarh from "./Docentes/AsignacionesSarh";
import DocentePlataforma from "./Docentes/DocentePlataforma";
import FormularioBasico from "./Sanidad/FormularioBasico";
import Resultados_SCL90 from "./SCL_90/Resultados_SCL90";
import CursosArmas from "./Armeria/CursosArmas";
import UnirPDF from "./Expedientes/UnirPDF.jsx";
import InformeEstadisticoExpedientes from "./Expedientes/InformeEstadisticoExpedientes";
import ReporteIncumbenciaDisponibilidad from "./Docentes/ReporteIncumbenciasDisponibilidad.jsx";
import ListadoSCL90 from "./SCL_90/ListadoSCL90";

import comprueboPermisos from "./tools/comprueboPermisos.js";
import ObtieneDatosCookies from "./obtieneDatosCookiesUsuario.js";
import AdministradorDependencias from "./tools/AdministradorDependencias.jsx";

// ============================================================
// RUTA DE REPORTE DE INCUMBENCIAS
// ============================================================

const ReporteIncumbenciasRoute = () => {
  const [usuario, setUsuario] = useState(null);
  const [cargandoUsuario, setCargandoUsuario] = useState(true);

  useEffect(() => {
    try {
      const usuarioActual = ObtieneDatosCookies();

      console.log(
        "Usuario desde ReporteIncumbenciasRoute:",
        usuarioActual
      );

      setUsuario(usuarioActual || null);
    } catch (error) {
      console.error(
        "Error al obtener el usuario:",
        error
      );

      setUsuario(null);
    } finally {
      setCargandoUsuario(false);
    }
  }, []);

  // Esperar la lectura de cookies
  if (cargandoUsuario) {
    return (
      <div className="container mt-4">
        <div className="alert alert-info">
          Cargando datos del usuario...
        </div>
      </div>
    );
  }

  // Sin sesión
  if (!usuario) {
    return (
      <div className="container mt-4">
        <div className="alert alert-warning">
          <strong>Sesión no encontrada.</strong>
          <p className="mb-0">
            No se pudieron obtener los datos del usuario.
            Por favor, iniciá sesión nuevamente.
          </p>
        </div>
      </div>
    );
  }

  // ==========================================================
  // COMPROBAR PERMISO DE GESTIÓN DE INCUMBENCIAS
  // ==========================================================

  let puedeGestionar = false;

  try {
    puedeGestionar = Boolean(
      comprueboPermisos(
        usuario.funcion || [],
        "Modifico Incumbencias al Docente"
      )
    );
  } catch (error) {
    console.error(
      "Error al comprobar permisos:",
      error
    );
  }

  console.log("Permiso gestión incumbencias:", puedeGestionar);

  // ==========================================================
  // RENDERIZAR REPORTE
  // ==========================================================

  return (
    <ReporteIncumbenciaDisponibilidad
      usuario={usuario}
      puedeGestionarIncumbencias={puedeGestionar}
    />
  );
};

// ============================================================
// COMPONENTE PRINCIPAL
// ============================================================

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <WebSocketHandler socket={socket} />

        <Routes>
          <Route
            path="/"
            element={<Loguin />}
          />

          <Route
            path="/reempadronamientoDatos"
            element={<CompoLuis />}
          />

          <Route
            path="/ReporteAsistenciaDocentes"
            element={<ReporteAsistenciaDocentes />}
          />

          <Route
            path="/ReporteIncumbenciaDisponibilidad"
            element={<ReporteIncumbenciasRoute />}
          />

          <Route
            path="/informeEstadisticoExpedientes"
            element={
              <InformeEstadisticoExpedientes
                apiUrl="https://wwwa.isepsantafe.net.ar/expedientes/informeEstadisticoExpedientes"
              />
            }
          />

          <Route
            path="/AsignacionesSarh"
            element={<AsignacionesSarh />}
          />

          <Route
            path="/Sanciones"
            element={<Sancionaa />}
          />

          <Route
            path="/Logistica"
            element={<Logistica />}
          />

          <Route
            path="/DocenteBuscador"
            element={<Main />}
          />

          <Route
            path="/Sanidad"
            element={<Sanidad />}
          />

          <Route
            path="/SelectorCompaniaSeccion"
            element={<SelectorCompaniaSeccion />}
          />

          <Route
            path="/DivisionCuerpo"
            element={<DivisionCuerpo />}
          />

          <Route
            path="/DivisionEstudio"
            element={<DivisionEstudio />}
          />

          <Route
            path="/CreaSancion"
            element={<CreaSancion />}
          />

          <Route
            path="/usuarioLogueado"
            element={<Edit />}
          />

          <Route
            path="/imprime"
            element={<GeneraCaratula />}
          />

          <Route
            path="/Docentes"
            element={<Docentes />}
          />

          <Route
            path="/DocenteEdit"
            element={<FormEditaDocente />}
          />

          <Route
            path="/imprimeRecibo"
            element={<GeneraRecibo />}
          />

          <Route
            path="/nuevoExpediente"
            element={<FormNuevoExpte />}
          />

          <Route
            path="/consultaExpediente"
            element={<ConsultaExpediente />}
          />

          <Route
            path="/LectorQr"
            element={<QRscanner />}
          />

          <Route
            path="/usuarios"
            element={<ModuloUsuarios />}
          />
          <Route
            path="/AdministradorDependencias"
            element={<AdministradorDependencias apiBaseUrl="https://wwwa.isepsantafe.net.ar/expedientes" />}
          />
          <Route
            path="/cambioContrasena"
            element={<CambiaContrasena />}
          />

          <Route
            path="/Postulante"
            element={<DevuelveLegajoInscripto />}
          />

          <Route
            path="/Cadetes"
            element={<Cadetes />}
          />

          <Route
            path="/Procesos"
            element={<MenuIngresos />}
          />

          <Route
            path="/Certificados"
            element={<Certificados />}
          />

          <Route
            path="/imprimeCertificado"
            element={<Constancia />}
          />

          <Route
            path="/imprimeReempadronamiento"
            element={<Reempadronamiento />}
          />

          <Route
            path="/envioMasivo"
            element={<EnvioMasivo />}
          />

          <Route
            path="/Calificaciones"
            element={<Calificaciones />}
          />

          <Route
            path="/NCadetes"
            element={<NCadetes />}
          />

          <Route
            path="/Resoluciones"
            element={<Resoluciones />}
          />

          <Route
            path="/Documentos"
            element={<Documentos />}
          />

          <Route
            path="/CadeteEdit"
            element={<CadetesEdit />}
          />

          <Route
            path="/GuardiaPrevencion"
            element={<GuardiaPrevencion />}
          />

          <Route
            path="/DTyD"
            element={<DTyD />}
          />

          <Route
            path="/Psico"
            element={<Psico />}
          />

          <Route
            path="/SanidadFormulario"
            element={<FormularioBasico />}
          />

          <Route
            path="/DocentePlataforma"
            element={<DocentePlataforma />}
          />

          <Route
            path="/ArmeriaPoligono"
            element={<CursosArmas />}
          />

          <Route
            path="/UnirPDF"
            element={<UnirPDF />}
          />

          <Route
            path="/scl-90-resultados"
            element={<Resultados_SCL90 />}
          />

          <Route
            path="/scl-90-listados"
            element={<ListadoSCL90 />}
          />

          <Route
            path="*"
            element={<NotFound />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
